import React from 'react';
import { Link } from 'react-router-dom';
import { useLang, tx } from '../context/LanguageContext';
import SEO from '../components/SEO';
import { SEO_TEXTES } from '../data/seoTextes';

// Page « introuvable » : câblée en <Route path="*">, pré-rendue sur /404 (reactSnap.include) puis copiée en
// build/404.html par scripts/prerender-fixup.js ; nginx la sert avec un vrai statut 404 (error_page 404).
export default function NotFound() {
  const { lang } = useLang();
  return (
    <>
      <SEO {...SEO_TEXTES['/404']} path="/404" noindex />
      <main data-testid="not-found-page" className="min-h-screen flex items-center justify-center pt-20 px-6">
        <div className="text-center max-w-xl">
          <p className="text-sm font-medium tracking-[0.2em] uppercase text-[#0099D6] mb-4">404</p>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-white mb-4">
            {tx(lang, 'Page introuvable', 'Page not found', { es: 'Página no encontrada', de: 'Seite nicht gefunden', it: 'Pagina non trovata', pt: 'Página não encontrada' })}
          </h1>
          <p className="text-slate-300 leading-relaxed mb-8">
            {tx(
              lang,
              "La page demandée n'existe pas ou a été déplacée.",
              'The page you requested does not exist or has moved.',
              {
                es: 'La página solicitada no existe o se ha movido.',
                de: 'Die angeforderte Seite existiert nicht oder wurde verschoben.',
                it: 'La pagina richiesta non esiste o è stata spostata.',
                pt: 'A página solicitada não existe ou foi movida.',
              }
            )}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="bg-[#0099D6] text-white text-sm font-semibold px-5 py-3 rounded-lg hover:bg-[#007fb3] transition-colors"
            >
              {tx(lang, "Retour à l'accueil", 'Back to home', { es: 'Volver al inicio', de: 'Zur Startseite', it: 'Torna alla home', pt: 'Voltar ao início' })}
            </Link>
            <Link to="/contact" className="text-[#0099D6] text-sm font-semibold hover:underline">
              {tx(lang, 'Nous contacter', 'Contact us', { es: 'Contáctenos', de: 'Kontakt', it: 'Contattaci', pt: 'Contacte-nos' })}
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
